import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementGas_Agreement on AgreementType {
            __typename
        }
    `),
}

type IsAgreementGasProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementGas(props: IsAgreementGasProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return agreement.__typename === "GasSpecificAgreementType"
}

isAgreementGas.fragments = graphQLFragments
